import React from 'react';

export default function TetherloSyncCell({ tetherlo }) {
  if (tetherlo?.synced) {
    return (
      <span
        style={{
          fontSize: 10,
          fontWeight: 600,
          color: '#15803D',
          background: '#DCFCE7',
          padding: '2px 8px',
          borderRadius: 99,
          width: 'fit-content',
        }}
      >
        Synced
      </span>
    );
  }

  return <span style={{ fontSize: 12, color: '#94A3B8' }}>Not synced</span>;
}
